import CurriculumCreationPage from "./CurriculumCreationPage";

export default CurriculumCreationPage;